/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";

import "bootstrap-icons/font/bootstrap-icons.css";

import "./styles.css";
import StatusPill from "./components/StatusPill";
import TabsBar from "./components/TabsBar";
import {
  CreditReportResponse,
  DocumentsObjectType,
  LoanEligibilityResponse,
  MasdarPayslip,
  PrivateSector,
  TabItem,
} from "./types";
import { COLORS } from "./constants";
import PersonalDetails from "./components/PersonalDetails";
import MonthlyExpensesView from "./components/MonthlyExpensesView";
import SalaryDetailsSection from "./components/SalaryDetails";
import DependentsView from "./components/DependentsView";
import OtherDetailsView from "./components/OtherDetails";
import ActionHistory from "./components/ActionHistory";
import EligibilityResult from "./components/EligibilityResult";
import ViewSimahData from "./components/ViewSimahData";
import DefaultsSimahView from "./components/DefaultsSimahView";
import BouncedChecksView from "./components/BouncedChecksView";
import JudgementsView from "./components/JudgementsView";
import SimahVerificationResultView from "./components/SimahVerificationResultView";
import SimahViewSalaryDetailsView from "./components/SimahViewSalaryDetailsView";
import SimahDBRView from "./components/SimahDBRView";
import SimahLivingExpenseView from "./components/SimahLivingExpenseView";
import AmlockView from "./components/AmlockView";
import SelectedOfferView from "./components/SelectedOfferView";
import EligibilityDataView from "./components/EligibilityDataView";
import EditSalaryPopup from "./components/EditSalaryPopup";
import DocumentView from "./components/DocumentView";
import DownloadConsent from "./components/DownloadConsent";
import { getManualSalaryDetails, getOfferDetails } from "./hook/API";
import API, { getFullURL } from "../../hooks/api";
import {
  MANUAL_SALARY_ACTION_HISTORY,
  MANUAL_SALARY_DOCUMENT_VIEW,
  MANUAL_SALARY_EDIT_SALARY,
  MANUAL_SALARY_MASDAR_PAYSLIP,
  MANUAL_SALARY_SIMAH_OBLIGATIONS,
  MANUAL_SALARY_UPDATE_STATUS,
} from "../../utils/Endpoints";
import { useLocation } from "react-router-dom";
import { ManualSalaryObject } from "./hook/ScreenHelper";
import ProvenirAdditionalRacDetails from "./components/ProvenirAdditionalRacDetails";
import { exportSimahReportToCSV } from "./hook/exportSimahReportToCSV";
import CustomAlert from "../../components/CustomAlert/CustomAlert";
import MasdarPayslipView from "./components/MasdarPayslip";
import { setErrorMsg } from "../../redux/reducers/settingsSlice";
import { store } from "../../redux/store";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";

export const ManualSalaryDetails: React.FC = () => {
  const [showHistory, setShowHistory] = useState(false);
  const [activeTab, setActiveTab] = useState("basic");
  const [status, setStatus] = useState<string>("");
  const [remark, setRemark] = useState<string>("");
  const isFormValid = status === 'APPROVE' ? true : status !== "" && remark.trim() !== "";
  const [activePersonalTab, setActivePersonalTab] = useState("personal");
  const [simahTab, setActiveSimahTab] = useState("");
  const [editSalary, setEditSalary] = useState(false);
  const [viewDocument, setViewDocument] = useState(false);
  const [consentDownload, setConsentDownload] = useState(false);
  const [completeDetails, setCompleteDetails] = useState<any>({});
  const [actionHistory, setActionHistory] = useState<any>({});
  const [showAlert, setShowAlert] = useState(false);
  const [viewDocumentInfo, setViewDocumentInfo] =
    useState<DocumentsObjectType>();
  const [simahData, setSimahData] = useState<CreditReportResponse | null>(null);
  const [offers, setOffers] = useState<LoanEligibilityResponse | null>(null);
  const [eligibilityDataCreated, setEeligibilityDataCreated] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const defaultPrivateSector = {
    basicWage: "",
    dateOfJoining: "",
    employerName: "",
    employmentStatus: "",
    establishmentActivity: "",
    fullName: "",
    fullWage: "",
    housingAllowance: "",
    otherAllowance: "",
    salaryStartingDate: "",
    workingMonths: ""
  }
  const [masdarData, setMasdarData] = useState<{
    masdarPaySlip: MasdarPayslip[];
    privateSector: PrivateSector;
  }>({ masdarPaySlip: [], privateSector: defaultPrivateSector });
  const locationObj = useLocation();

  const handleClick = React.useCallback(() => {
    window.history.back();
  }, []);

  const tabList = React.useMemo<TabItem[]>(
    () => [
      { id: "basic", label: "Basic Details", disabled: false },
      { id: "eligibilityResult", label: "Eligibility Result", disabled: false },
      { id: "amlock", label: "Amlock", disabled: false },
      { id: "offers", label: "Offers", disabled: false },
      { id: "eligibilityData", label: "Eligibility Data", disabled: false },
    ],
    []
  );

  const tabListOfPersonalDetails = React.useMemo<TabItem[]>(
    () => [
      { id: "personal", label: "Personal details", disabled: false },
      { id: "monthlyExpenses", label: "Monthly Expenses", disabled: false },
      { id: "dependents", label: "Number of Dependents", disabled: false },
      { id: "otherDetails", label: "Other Details", disabled: false },
    ],
    []
  );

  const simahTabsData = React.useMemo<TabItem[]>(
    () => [
      { id: "viewSimahData", label: "View SIMAH Data", disabled: false },
      {
        id: "simahVerificationResults",
        label: "SIMAH Verification Results",
        disabled: false,
      },
      {
        id: "viewSalaryDetails",
        label: "View Salary Details",
        disabled: false,
      },
      { id: "dbr", label: "DBR", disabled: false },
      {
        id: "livingExpensesCalculated",
        label: "Living Expenses Calculated",
        disabled: false,
      },
      {
        id: "provenirAdditionalRacDetails",
        label: "Provenir additional RAC details",
        disabled: false,
      },
    ],
    []
  );

  const financialContext = React.useMemo(() => {
    const detailObj = locationObj?.state as ManualSalaryObject | undefined;
    return {
      financialId: detailObj?.financialDataId ?? 0,
      stage: detailObj?.salaryStage ?? "PENDING",
      salaryType: detailObj?.salaryType ?? "MANUAL"
    };
  }, [locationObj]);

  useEffect(() => {
    const financeId = financialContext.financialId;
    if (!financeId) return;

    getManualSalaryDetails(financeId, (success, data) => {
      if (success && data) setCompleteDetails(data);
    });
    if (financialContext.stage !== "REJECTED" || financialContext.salaryType === 'MASDR') {
      getOfferDetails(financeId, (success, data) => {
        if (success && data) {
          if (data?.provenierResponseData) {
            setOffers(data?.provenierResponseData);
          }
          setEeligibilityDataCreated(data?.createdOn ?? "");
          setRejectionReason(data?.rejectionReason ?? "");
        }
      });
    }
  }, [financialContext.financialId]);

  const handleDocumentView = (document: DocumentsObjectType) => {
    setViewDocumentInfo(document);
    // setViewDocument(true);
    setConsentDownload(true);
  };

  const handleDownload = async () => {
    setConsentDownload(false);
    const financeId = financialContext.financialId;
    if (!viewDocumentInfo) return;
    if (financeId) {
      try {
        const res = await API.get(getFullURL(MANUAL_SALARY_DOCUMENT_VIEW), {
          params: {
            id: financeId,
            docType: viewDocumentInfo.docType,
          },
          responseType: "blob",
        });

        if (!res?.data) {
          console.error("PDF data is missing");
          return;
        }

        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${viewDocumentInfo.title}`;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("PDF download failed", error);
      }
    }
  };

  const viewPdfDocument = () => {
    setConsentDownload(false);
    setViewDocument(true);
  };

  const submitStatusUpdate = async () => {
    const id = financialContext.financialId;
    if (id) {
      const data = {
        id: id,
        action: status,
        remark: remark,
      };
      await API.put(getFullURL(MANUAL_SALARY_UPDATE_STATUS), data)
        .then((res) => {
          window.history.back();
        })
        .catch((err) => {
          window.history.back();
        });
    }
  };

  const onStausUpdate = () => {
    if (!completeDetails?.salaryDetails?.employerName && status === "APPROVE") {
      setShowAlert(true);
      return;
    }

    store.dispatch(
      setErrorMsg({
        icon: null,
        cancelBtnTitle: "Cancel",
        acceptBtnTitle: "Update",
        modalContentClass: "small",
        title: "Are you sure you want to " + status.toLowerCase() + " this?",
        message: remark.trim() !== "" ? "Remark: " + remark : null,
        acceptBtnAction: () => submitStatusUpdate(),
      })
    );
  };

  const onClickActionHistory = async () => {
    const id = financialContext.financialId;
    if (id) {
      await API.get(getFullURL(MANUAL_SALARY_ACTION_HISTORY + id))
        .then((res) => {
          if (res?.data) {
            setActionHistory(res?.data);
            setShowHistory(true);
          }
        })
        .catch((err) => {
          setShowHistory(true);
        });
    }
  };

  const reCalculateSimahData = async () => {
    // if (completeDetails?.salaryDetails?.employerName) {
    const financeId = financialContext.financialId;
    if (financeId) {
      getOfferDetails(financeId, (success, data) => {
        if (success && data) {
          if (data?.provenierResponseData) {
            setOffers(data?.provenierResponseData);
          }
          setEeligibilityDataCreated(data?.createdOn ?? "");
          setRejectionReason(data?.rejectionReason ?? "");
        }
      });
    }
    // } else {
    //   setShowAlert(true);
    // }
  };

  const getMasdarPayslip = async () => {
    const id = financialContext.financialId;
    if (id) {
      await API.get(getFullURL(MANUAL_SALARY_MASDAR_PAYSLIP + id))
        .then((res) => {
          if (res?.data) {
            const masdarPaySlip =
              res?.data?.salaryRulesSalary?.salaryRulesData ?? [];
            const privateSector =
              Array.isArray(res?.data?.privateSector) &&
              res.data.privateSector.length > 0
                ? (res.data.privateSector[0] as PrivateSector)
                : ({} as PrivateSector);
            setMasdarData({
              masdarPaySlip,
              privateSector,
            });
          }
        })
        .catch((err) => {
          setMasdarData({masdarPaySlip: [], privateSector: defaultPrivateSector});
        });
    }
  };

  const isStatusPending = financialContext.stage === "PENDING";

  const changeTab = async (tabId: string) => {
    setActiveTab(tabId);
  };

  const changeSimahDataTab = async (tabId: string) => {
    setActiveSimahTab(tabId);
    if (
      tabId === "viewSalaryDetails" &&
      financialContext.salaryType === "MASDR" &&
      masdarData?.masdarPaySlip.length === 0
    ) {
      getMasdarPayslip();
    } else {
      if (
        tabId !== "viewSimahData" ||
        simahData ||
        !financialContext.financialId
      ) {
        return;
      }

      try {
        const body = {
          nationalId: completeDetails?.nationalId,
          referanceNumber: financialContext.financialId,
        };

        const res = await API.get(getFullURL(MANUAL_SALARY_SIMAH_OBLIGATIONS), {
          params: body,
        });

        if (res?.data) setSimahData(res.data);
      } catch {
        // silent fail (existing behavior preserved)
      }
    }
  };

  const onSalaryEdit = async (data: any) => {
    const id = financialContext.financialId;
    if (id) {
      await API.put(getFullURL(MANUAL_SALARY_EDIT_SALARY + id), data)
        .then((res) => {
          // Update completeDetails.salaryDetails with the new data
          setCompleteDetails((prevDetails: any) => {
            if (!prevDetails || !prevDetails.salaryDetails) {
              return prevDetails;
            }

            // Map numeric fields
            const numericFields = [
              "basicSalary",
              "housingAllowance",
              "otherAllowance",
            ];
            const updatedSalaryDetails: any = { ...prevDetails.salaryDetails };

            // Update all fields from data
            Object.keys(data).forEach((key) => {
              if (key === "salaryDocUrl") {
                updatedSalaryDetails.salaryCertificateUrl =
                  data[key] ?? updatedSalaryDetails.salaryCertificateUrl;
              } else if (key === "bankDocUrl") {
                updatedSalaryDetails.bankStatementUrl =
                  data[key] ?? updatedSalaryDetails.bankStatementUrl;
              } else if (key === "gosiDocUrl") {
                updatedSalaryDetails.gosiCertificateUrl =
                  data[key] ?? updatedSalaryDetails.gosiCertificateUrl;
              } else if (numericFields.includes(key)) {
                updatedSalaryDetails[key] =
                  data[key] !== undefined
                    ? Number(data[key])
                    : updatedSalaryDetails[key];
              } else {
                updatedSalaryDetails[key] =
                  data[key] ?? updatedSalaryDetails[key];
              }
            });

            return {
              ...prevDetails,
              salaryDetails: updatedSalaryDetails,
            };
          });
          const financeId = financialContext.financialId;

          // getManualSalaryDetails(financeId, (success, data) => {
          //   if (success && data) setCompleteDetails(data);
          // });

          getOfferDetails(financeId, (success, data) => {
            if (success && data) {
              if (data?.provenierResponseData) {
                setOffers(data?.provenierResponseData);
              }
              setEeligibilityDataCreated(data?.createdOn ?? "");
              setRejectionReason(data?.rejectionReason ?? "");
            }
          });
          setEditSalary(false);
        })
        .catch((err) => {
          setEditSalary(false);
        });
    }
  };

  const hasSimahData =
    simahData &&
    (simahData?.creditInstruments?.length > 0 ||
      simahData?.defaults?.length > 0 ||
      simahData?.bouncedChecks?.length > 0 ||
      simahData?.judgements?.length > 0);

  return (
    <div className="text">
      <div className="d-flex flex-column align-items-start">
        {" "}
        <button
          className="btn d-flex align-items-center gap-2 p-0 pe-2"
          onClick={handleClick}
          style={{ fontWeight: 700, color: "#000000" }}
        >
          <i
            className="bi bi-chevron-left"
            style={{ fontWeight: 700, color: "#000000" }}
          ></i>
          Back
        </button>
        <p
          className="text-dark fw-bold fs-5 m-0"
          style={{ color: COLORS.TEXT_PRIMARY }}
        >
          Salary Certificate
        </p>
        <div className="d-flex flex-row pt-2 mt-4 align-items-center">
          <button
            className="btn d-flex align-items-center gap-2 p-1 px-3 m-1 me-4 action-history-btn"
            onClick={onClickActionHistory}
          >
            Action History
          </button>
          <StatusPill status={financialContext.stage} />
        </div>
        <div
          className="d-flex box_container flex-column"
          style={{ width: "100%", padding: 25, marginTop: 25 }}
        >
          <TabsBar
            tabs={tabList}
            activeTab={activeTab}
            onChange={(tabId) => changeTab(tabId)}
          />
          {activeTab === "eligibilityResult" && (
            <>
              <EligibilityResult data={offers} />
              <TabsBar
                tabs={simahTabsData}
                activeTab={simahTab}
                onChange={(tabId) => changeSimahDataTab(tabId)}
              />
              {simahTab === "viewSimahData" && (
                <>
                  {hasSimahData && (
                    <div
                      style={{ marginTop: 30 }}
                      className="d-flex justify-content-end"
                    >
                      <button
                        type="button"
                        onClick={() =>
                          exportSimahReportToCSV(
                            simahData,
                            "simah_credit_report"
                          )
                        }
                        className="btn d-flex align-items-center gap-3 px-3 py-1 export-simah-btn"
                      >
                        <i className="bi bi-cloud-arrow-down fs-4" />
                        <span className="fw-semibold fs-6">
                          Export SIMAH Data
                        </span>
                      </button>
                    </div>
                  )}
                  <ViewSimahData data={simahData?.creditInstruments ?? []} />
                  <DefaultsSimahView data={simahData?.defaults ?? []} />
                  <BouncedChecksView data={simahData?.bouncedChecks ?? []} />
                  <JudgementsView data={simahData?.judgements ?? []} />
                </>
              )}
              {simahTab === "simahVerificationResults" && (
                <>
                  <SimahVerificationResultView
                    data={offers?.EligibilityResult?.SimahVerificationResult}
                  />
                </>
              )}
              {simahTab === "viewSalaryDetails" && (
                <>
                  <SimahViewSalaryDetailsView
                    data={completeDetails?.salaryDetails}
                    netIncome={
                      offers?.EligibilityResult?.DbrResult?.netIncome
                        ? `${offers.EligibilityResult.DbrResult.netIncome}`
                        : "-"
                    }
                    masdarSalary={masdarData?.privateSector}
                  />
                  {masdarData?.masdarPaySlip && (
                    <MasdarPayslipView payslipData={masdarData.masdarPaySlip} />
                  )}
                </>
              )}
              {simahTab === "dbr" && (
                <>
                  <SimahDBRView data={offers?.EligibilityResult?.DbrResult} />
                </>
              )}
              {simahTab === "livingExpensesCalculated" && (
                <>
                  <SimahLivingExpenseView
                    data={offers?.EligibilityResult?.LivingExpenseCalculated}
                  />
                </>
              )}
              {simahTab === "provenirAdditionalRacDetails" && (
                <>
                  <ProvenirAdditionalRacDetails
                    data={completeDetails?.salaryDetails}
                  />
                </>
              )}
            </>
          )}
          {activeTab === "amlock" && (
            <AmlockView amlockDetails={completeDetails?.amlockDetails} />
          )}
          {activeTab === "offers" && (
            <SelectedOfferView
              offerData={offers}
              status={financialContext.stage}
            />
          )}
          {activeTab === "eligibilityData" && (
            <EligibilityDataView
              userDetails={completeDetails?.userProfile}
              nationalId={completeDetails?.nationalId}
              sector={completeDetails?.salaryDetails?.sector}
              dbr={offers?.EligibilityResult?.DbrResult}
              requestedLoan={String(offers?.requested_loan ?? "-")}
              orderStatus={
                offers?.orderStatus === "OTHER"
                  ? offers?.OfferCode ?? "-"
                  : offers?.orderStatus ?? "-"
              }
              racResult={offers?.EligibilityResult?.RACResult}
              createdOn={eligibilityDataCreated}
              offer={offers?.offer ?? []}
              rejectionReason={rejectionReason}
            />
          )}
        </div>
        {activeTab === "basic" && (
          <>
            {isStatusPending && (
              <div
                className="d-flex flex-column box_container"
                style={{ width: "100%", padding: 25, marginTop: 25 }}
              >
                <p
                  className="text-dark fw-bold fs-5 m-0"
                  style={{ color: COLORS.TEXT_PRIMARY }}
                >
                  Status
                </p>

                <div className="row align-items-end mt-3">
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">
                      Salary certificate Status{" "}
                      <span className="text-danger">*</span>
                    </label>

                    <div
                      style={{
                        background: "#f8f8f8",
                        borderRadius: 16,
                        padding: "10px 16px",
                      }}
                      className="dropdown"
                    >
                      <button
                        className="w-100 d-flex justify-content-between align-items-center border-0 bg-transparent"
                        data-bs-toggle="dropdown"
                        style={{
                          padding: 0,
                          margin: 0,
                          boxShadow: "none",
                          outline: "none",
                          fontSize: 16,
                          color: status ? "#000" : "#8c8c8c",
                        }}
                        type="button"
                      >
                        {status || "Select status"}
                        <i className="bi bi-chevron-down"></i>
                      </button>

                      <ul
                        className="dropdown-menu shadow"
                        style={{
                          borderRadius: 12,
                          background: "#ffffff",
                          padding: "10px 10px",
                        }}
                      >
                        <li>
                          <button
                            className="dropdown-item text-success fw-normal"
                            onClick={() => setStatus("APPROVE")}
                          >
                            Approve
                          </button>
                        </li>
                        {financialContext.salaryType !== "MASDR" && (
                          <li>
                            <button
                              className="dropdown-item fw-normal"
                              style={{ color: "#d4a200" }}
                              onClick={() => setStatus("REWORK")}
                            >
                              Rework
                            </button>
                          </li>
                        )}
                        <li>
                          <button
                            className="dropdown-item text-danger fw-normal"
                            onClick={() => setStatus("REJECT")}
                          >
                            Reject
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-5">
                    <label className="form-label fw-semibold">Remark</label>

                    <div
                      style={{
                        background: "#f8f8f8",
                        borderRadius: 16,
                      }}
                    >
                      <input
                        type="text"
                        className="form-control input-no-border border-0"
                        placeholder="Remarks"
                        style={{
                          background: "#f8f8f8",
                          boxShadow: "none",
                          borderRadius: 16,
                          border: "none",
                          outline: "none",
                          padding: "10px 16px",
                        }}
                        onChange={(e) => setRemark(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-2 d-flex">
                    <button
                      type="button"
                      className="btn text-white ms-md-3"
                      style={{
                        backgroundColor: isFormValid
                          ? COLORS.BUTTON_PRIMARY
                          : COLORS.BUTTON_DISABLED,
                        borderRadius: 12,
                        padding: "10px 32px",
                        fontWeight: 600,
                        cursor: isFormValid ? "pointer" : "not-allowed",
                      }}
                      disabled={!isFormValid}
                      onClick={onStausUpdate}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
            {completeDetails?.salaryDetails && (
              <div
                className="d-flex flex-column box_container"
                style={{ width: "100%", padding: 25, marginTop: 25 }}
              >
                <SalaryDetailsSection
                  handleEditSalary={() => setEditSalary(true)}
                  handleDocumentView={handleDocumentView}
                  reCalculateSimahData={reCalculateSimahData}
                  salaryData={completeDetails?.salaryDetails}
                  enableButtons={isStatusPending}
                />
              </div>
            )}
            <div
              className="d-flex flex-column box_container"
              style={{ width: "100%", padding: 25, marginTop: 25 }}
            >
              <TabsBar
                tabs={tabListOfPersonalDetails}
                activeTab={activePersonalTab}
                onChange={(tabId) => setActivePersonalTab(tabId)}
              />
              {activePersonalTab === "personal" && (
                <PersonalDetails
                  data={completeDetails?.userProfile}
                  nationalId={completeDetails?.nationalId}
                />
              )}
              {activePersonalTab === "monthlyExpenses" && (
                <MonthlyExpensesView
                  data={completeDetails?.userProfile?.monthlyExpenses || {}}
                />
              )}
              {activePersonalTab === "dependents" && (
                <DependentsView
                  data={completeDetails?.userProfile?.dependents || {}}
                />
              )}
              {activePersonalTab === "otherDetails" && (
                <OtherDetailsView data={completeDetails?.userProfile || {}} />
              )}
            </div>
          </>
        )}
      </div>
      <>
        {showHistory && (
          <ActionHistory
            close={() => {
              setShowHistory(false);
            }}
            history={actionHistory}
            processId={financialContext.financialId}
          />
        )}
      </>
      <>
        {editSalary && (
          <EditSalaryPopup
            close={() => {
              setEditSalary(false);
            }}
            salaryDetails={completeDetails?.salaryDetails}
            save={onSalaryEdit}
            financialDataId={financialContext.financialId}
            salaryType={financialContext.salaryType}
          />
        )}
        {viewDocument && (
          <DocumentView
            close={() => {
              setViewDocument(false);
            }}
            viewDocumentInfo={viewDocumentInfo}
            financialId={financialContext.financialId}
          />
        )}
        {consentDownload && (
          <DownloadConsent
            close={() => {
              setConsentDownload(false);
            }}
            view={viewPdfDocument}
            download={handleDownload}
            viewDocumentInfo={viewDocumentInfo}
          />
        )}
      </>
      {showAlert && (
        <CustomAlert
          message="Please enter Employer Name in Edit Salary Details"
          // variant="warning"
          onClose={() => setShowAlert(false)}
        />
      )}
    </div>
  );
};
